import { createSelector } from 'reselect'

export const getInfiniteScrollEnabled = createSelector(
  (state) => state && state.ads && state.ads.list && state.ads.list.infiniteScrollEnabled,
  infiniteScrollEnabled => infiniteScrollEnabled
)
